import { Invoice, Money } from "@oysterhr/schema"

export const getClientInvoiceAmount = ({
  totalAmount,
  prePaidAmount,
}: Pick<Invoice, "totalAmount" | "prePaidAmount">): Money | undefined => {
  if (!totalAmount) {
    return
  }

  return {
    ...totalAmount,
    subunit: Math.max(totalAmount.subunit - (prePaidAmount?.subunit || 0), 0),
  }
}
